import type { DataGridLeafColumn } from '@ibsys/kit';
import { cn } from '@/shared/lib';

/**
 * Класс ячейки, при наведении на которую показывается кнопка копирования её значения.
 * Парный ему `group-hover/copy-cell:` живёт в разметке `CopyableCell`.
 */
const COPYABLE_CELL_HOVER_HOST = 'group/copy-cell';

/** Готовит колонку `DataGrid` с ячейками `CopyableCell`: кнопка появляется по наведению на ячейку. */
export const withCopyableCellHover = <TData>(column: DataGridLeafColumn<TData>): DataGridLeafColumn<TData> => ({
  ...column,
  className: cn(COPYABLE_CELL_HOVER_HOST, column.className),
});
